export enum UserPreferenceRestrictiveUiType {
    SAME_AS_BRAND = 'SAME_AS_BRAND',
    CUSTOM = 'CUSTOM',
}

export enum BrandRestrictiveUiType {
    DEFAULT = 'DEFAULT',
    RESTRICTIVE = 'RESTRICTIVE',
}
